module.exports = __webpack_public_path__ + "static/media/sun-cloud.3ed5a367.svg";